import Choices from "choices.js";

export function initChoices(select: HTMLSelectElement, { expression }, { evaluate, evaluateLater, cleanup, effect }): void {
    const data = evaluate(expression) ?? { };

    const choices = new Choices(select, {
        removeItems: true,
        removeItemButton: true,
        duplicateItemsAllowed: false,
        searchEnabled: 'searchable' in data ? data.searchable : true,
        shouldSort: false,
    });

    if ('onChange' in data) {
        const listener = () => data.onChange(choices.getValue(true) ?? null)
        select.addEventListener('change', listener);
        cleanup(() => select.removeEventListener('change', listener));
    }

    // Reactivity below
    if (expression) {
        const getData = evaluateLater(expression);

        // Update choices state if value changes
        if ('value' in data) {
            effect(() => {
                getData(data => {
                    const rawValue = data.value ?? null;
                    let value: string[];
                    if (Array.isArray(rawValue)) {
                        value = rawValue;
                    } else if (typeof rawValue === 'string' || typeof rawValue === 'number') {
                        value = [ `${rawValue}` ];
                    } else {
                        value = [ ];
                    }

                    choices.removeActiveItems(-1);
                    choices.setChoiceByValue(value);
                });
            });
        }

        // Set choices via data
        if ('options' in data) {
            effect(() => {
                getData(data => {
                    let formattedOptions = [ ];
                    if (Array.isArray(data.options)) {
                        formattedOptions = [ ...data.options ];
                    } else {
                        for (const [ value, label ] of Object.entries(data.options)) {
                            formattedOptions.push({ value, label });
                        }
                    }
                    choices.setChoices(formattedOptions, 'value', 'label', true);
                });
            });
        }
    }
}
